/**
 * First non-blank value found in `column` across the sample rows, or `null`
 * when the column is unset or every sampled value is blank. Powers the
 * "Przykład z pliku" example-value cell in `ColumnMappingTable` — lets an
 * operator confirm a column pick against a real value instead of just the
 * header name.
 */
export function pickSampleValue(
  sampleRows: Record<string, string>[],
  column: string | null,
): string | null {
  if (!column) return null;
  for (const row of sampleRows) {
    const raw = row[column]?.trim();
    if (raw) return raw;
  }
  return null;
}
